/* global axios */
import ApiClient from './ApiClient';

export const buildContactParams = (
  page,
  sortAttr,
  label,
  search,
  channel,
  identifier,
  name,
  email,
  phone
) => {
  let params = `include_contact_inboxes=true&page=${page}&sort=${sortAttr}`;

  if (channel) {
    params = `${params}&inbox_name=${channel}`;
  }

  if (identifier) {
    params = `${params}&identifier=${identifier}`;
  }

  if (name) {
    params = `${params}&name=${name}`;
  }

  if (email) {
    params = `${params}&email=${email}`;
  }

  if (phone) {
    params = `${params}&phone_number=${phone}`;
  }

  if (search) {
    params = `${params}&q=${search}`;
  }
  if (label) {
    params = `${params}&labels[]=${label}`;
  }
  return params;
};

class ContactAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  get(page, sortAttr = 'name', label = '') {
    let requestURL = `${this.url}?${buildContactParams(
      page,
      sortAttr,
      label,
      ''
    )}`;
    return axios.get(requestURL);
  }

  // eslint-disable-next-line class-methods-use-this
  getReport(
    page,
    sortAttr = 'name',
    label = '',
    channel = '',
    identifier = '',
    name = '',
    email = '',
    phone = ''
  ) {
    const url = 'api/v1/inboxes/contacts';

    let requestURL = `${url}?${buildContactParams(
      page,
      sortAttr,
      label,
      '',
      channel,
      identifier,
      name,
      email,
      phone
    )}`;
    return axios.get(requestURL);
  }

  getConversations(contactId) {
    return axios.get(`${this.url}/${contactId}/conversations`);
  }

  getContactableInboxes(contactId) {
    return axios.get(`${this.url}/${contactId}/contactable_inboxes`);
  }

  getContactLabels(contactId) {
    return axios.get(`${this.url}/${contactId}/labels`);
  }

  updateContactLabels(contactId, labels) {
    return axios.post(`${this.url}/${contactId}/labels`, { labels });
  }

  search(search = '', page = 1, sortAttr = 'name', label = '') {
    let requestURL = `${this.url}/search?${buildContactParams(
      page,
      sortAttr,
      label,
      search
    )}`;
    return axios.get(requestURL);
  }

  // eslint-disable-next-line default-param-last
  filter(page = 1, sortAttr = 'name', queryPayload) {
    let requestURL = `${this.url}/filter?${buildContactParams(page, sortAttr)}`;
    return axios.post(requestURL, queryPayload);
  }

  importContacts(file) {
    const formData = new FormData();
    formData.append('import_file', file);
    return axios.post(`${this.url}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  destroyCustomAttributes(contactId, customAttributes) {
    return axios.post(`${this.url}/${contactId}/destroy_custom_attributes`, {
      custom_attributes: customAttributes,
    });
  }

  destroyAvatar(contactId) {
    return axios.delete(`${this.url}/${contactId}/avatar`);
  }

  exportContacts(queryPayload) {
    return axios.post(`${this.url}/export`, queryPayload);
  }

  preciseSearch({ username, inboxId }) {
    return axios.post(`${this.url}/precise_search`, {
      username,
      inbox_id: inboxId,
    });
  }
}

export default new ContactAPI();
